import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home-slider-create',
  templateUrl: './home-slider-create.component.html',
  styleUrls: ['./home-slider-create.component.scss']
})
export class HomeSliderCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

      ngOnInit() {
    this.Form = this.formBuilder.group({
      image: ['', Validators.required],
      heading: ['', Validators.required],
      content: ['', [Validators.required]],
      seohidden: [''],
      _id: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/homesliderbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              image: data.data.image,
              heading: data.data.heading,
              content: data.data.content,
              _id: data.data._id,
              seohidden: data.data.seohidden
            })
            
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              image: '',
              heading: '',
              content: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
  });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "image"      : this.Form.value.image,
        "heading"      : this.Form.value.heading,
        "content"  : this.Form.value.content,
        "admin" : sessionStorage.getItem('adminName'),
        "_id"   : this.Form.value._id,
        "seohidden" : this.Form.value.seohidden
      };
      this.http.put<any>(this.api_endpoint+'/homeslider', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/homeslider/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "image"      : this.Form.value.image,
        "heading"      : this.Form.value.heading,
        "content"  : this.Form.value.content,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden" : this.Form.value.seohidden
      };
      this.http.post<any>(this.api_endpoint+'/homeslider', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/homeslider/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
